<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row justify="center" dense>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Course Marks Calculation" value="course" color="#0f2027"></v-radio>
                <v-radio label="Annual Marksheet Calculation" value="marksheet" color="#0f2027"></v-radio>
            </v-radio-group>
        </v-row>
        <v-card class="box" v-if="ay_std_div_list != null && radios=='course'">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Annual Course Marks Calculation </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
              getStandardCourse();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs_id" item-value="c_id"
                        :items="crs_list" item-text="course" label="Course" outlined persistent-hint
                        hint="Please select course" />
                </v-col>

                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div && crs_id && assessment_detail
          ">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="leraner_marks!=''" dense justify="center"> 
                <strong><v-icon color="green">mdi-checkbox-blank-circle</v-icon> - Absent <v-icon color="yellow">mdi-checkbox-blank-circle</v-icon> - Medical Leave  <v-icon color="red">mdi-checkbox-blank-circle</v-icon> - Marks entry not done for all exam</strong>
            </v-row>
            <div class="scroll" v-if="leraner_marks!=''">
                <v-simple-table dense class="elevation-1" v-if="leraner_marks!=''" style="width:140%;" height="500px">
                    <thead>
                        <tr>
                            <th class="">
                                <center>Roll No.</center>
                            </th>
                            <th class="">
                                <center>Registration No.</center>
                            </th>
                            <th class="">
                                <center>Name</center>
                            </th>
                            <th class="" v-for="header in ass_details_for_marksheet" :key="header">
                                <center>{{ header }}</center>
                            </th>
                            <th class="">
                                <center>Total Marks</center>
                            </th>
                            <th class="">
                                <center>Out Off Marks</center>
                            </th>
                            <th class="">
                                <center>Grade</center>
                            </th>
                            <th class="">
                                <center>Save/Update</center>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in leraner_marks" :key="s.cid"
                        :class="{
                            'bg-green': s.all_marks.includes('AB'),
                            'bg-yellow': s.all_marks.includes('ML'),
                            'bg-red': s.all_marks.includes('--') && !s.all_marks.includes('ML') && !s.all_marks.includes('AB')
                        }">
                            <td>{{ s.rollno }}</td>
                            <td>{{ s.registration_number }}</td>
                            <td>{{ s.name }}</td>
                            <td v-for="(header, index) in s.all_marks" :key="index">
                                <center>
                                    {{ header }}
                                </center>
                            </td>
                            <td>
                                <input placeholder="Enter total marks" class="input text-center" type="number"
                                    v-model="s.total_marks" :name="s.cid" :rules="[v => !!v || 'Required' || v >= 0]"
                                    @keypress="isNumber($event)" />
                            </td>
                            <td>
                                <input placeholder="Enter out off marks" class="input text-center" type="number"
                                    v-model="s.out_off_marks" :name="s.cid" :rules="[v => !!v || 'Required' || v >= 0]"
                                    @keypress="isNumber($event)" />
                            </td>
                            <td>
                                <v-autocomplete dense required outlined rounded color="#0F2027" v-model="s.grade"
                                    :items="grade_details" item-text="gradename" label="Grade" persistent-hint
                                    hint="Please select grade" />
                            </td>
                            <td><v-btn class="button" :class="{
                            'bg-green': s.all_marks.includes('AB'),
                            'bg-yellow': s.all_marks.includes('ML'),
                            'bg-red': s.all_marks.includes('--') && !s.all_marks.includes('ML') && !s.all_marks.includes('AB')
                        }" x-small :disabled="s.all_marks.includes('--')" @click="savesinglecoursemarks(s)">save/update</v-btn></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
            <center><v-btn v-if="leraner_marks!=''" class="button"
                    @click="saveallstudmarks(leraner_marks)">save/update</v-btn></center>
        </v-card>

        <v-card class="box" v-if="ay_std_div_list != null && radios=='marksheet'">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Annual Course Marks Calculation </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
            " persistent-hint hint="Please select standard" @click="putnull" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="
            sel_ay_data && sel_std_data && div  && assessment_detail
          ">
                    <v-btn class="mt-6 button" @click="getreport_marksheet()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="leraner_marks_markseet!=''">
                <v-simple-table fixed-header dense class="elevation-1">
                    <thead>
                        <tr>
                            <th class="">
                                <center>Sr. No.</center>
                            </th>
                            <th class="">
                                <center>Roll No.</center>
                            </th>
                            <th class="">
                                <center>Registration No.</center>
                            </th>
                            <th class="">
                                <center>Name</center>
                            </th>
                            <th class="">
                                <center>Total Marks</center>
                            </th>
                            <th class="">
                                <center>Obtained Marks</center>
                            </th>
                            <th class="">
                                <center>Percentage</center>
                            </th>
                            <th class="">
                                <center>Fail Subject Count</center>
                            </th>
                            <th class="">
                                <center>Rank</center>
                            </th>
                            <th class="">
                                <center>Already Assigned Rank</center>
                            </th>
                            <th class="">
                                <center>Hide Show Marksheet</center>
                            </th>
                            <th class="">
                                <center>Save/Update</center>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in leraner_marks_markseet" :key="s.lid">
                            <td>{{ index + 1 }}</td>
                            <td>{{ s.rollno }}</td>
                            <td>{{ s.registration_number }}</td>
                            <td>{{ s.name }}</td>
                            <td>{{ s.totalmarks }}</td>
                            <td>{{ s.obtained_marks }}</td>
                            <td>{{ s.percentage_converted }}</td>
                            <td>{{ s.count }}</td>
                            <td>{{ s.result_rank }}</td>
                            <td>{{ s.lams_rank }}</td>
                            <td>
                                <center>
                                    <v-switch v-model="s.hide_show_percentage"
                                        :color="s.hide_show_percentage ? 'success' : 'primary'"></v-switch>
                                </center>
                            </td>
                            <td><v-btn class="button" x-small @click="saveSingleLMS(s)">save/update</v-btn></td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <center><v-btn class="button" @click="saveAllStudLMS(leraner_marks_markseet)">save/update</v-btn>
                </center>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data() {
            return {
                overlay: false,
                selected: [],
                // extraBreadcrumbItems: [


                // ],
                breadcrumbClass: "breadcrumb-style1",
                snackbar: false,
                course_list: [],
                crs_id: null,
                search: "",
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: [],
                leraner_marks: [],
                standard: null,
                division: null,
                course: null,
                academicyear: null,
                ass_detail_list: null,
                learner_course_list: null,
                org_basic_data: [],
                remarks_list: [],
              //  remarks_list_marksheet:[],
                leraner_marks_markseet:[],
                leraner_marathi_markseet_data:[],
                grade_details:[],
                radios:[],
            };
        },

        methods: {
            division_cal(s){
                if(s.avg_count!=0){
                    s.avg = s.total_marks / s.avg_count
                }
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
                const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = name + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },

            myfunction() {
                for (var i = 0; i < this.learner_course_list.length; i++) {
                    var formattter = Math.round(this.learner_course_list[i].converted_marks);
                }
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            async saveallstudmarks(item) {
                const data = {
                    marks_data: item,
                };
                try {
                    const res = await axios.post("/SanjivaniExamination/saveallstudcoursemarks", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Marks save successfully");
                        this.getreport();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async savesinglecoursemarks(item) {
                try {
                    const res = await axios.post("/SanjivaniExamination/savesinglecoursemarks", item);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Marks save successfully");
                        this.getreport();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async saveAllStudLMS(item) {
                const data = {
                    marks_data: item,
                };
                try {
                    const res = await axios.post("/SanjivaniExamination/saveAllStudLMS", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getreport_marksheet();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async saveSingleLMS(item) {
                try {
                    const res = await axios.post("/SanjivaniExamination/saveSingleLMS", item);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.getreport_marksheet();
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async getreport_marksheet(){
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                    div: this.div,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/SanjivaniExamination/annualMarksheetCalculation", data);
                    if (res.data.flag == "YES") {
                        this.leraner_marks_markseet = res.data.leraner_marks
                        let studentsByDivision = this.leraner_marks_markseet.reduce((result, student) => {
                                    if (!result[student.div]) {
                                        result[student.div] = [];
                                    }
                                    result[student.div].push(student);
                                    return result;
                                }, {});

                                Object.keys(studentsByDivision).forEach((division) => {
                                    let divisionStudents = studentsByDivision[division];

                                    // Sort by percentage in descending order
                                    divisionStudents.sort((a, b) => b.percentage - a.percentage);

                                    // Assign rank based on sorted order
                                    divisionStudents.forEach((student, index) => {
                                        if(student.fail_count > 0){
                                            student.result_rank = "F"+student.fail_count
                                        }
                                        else{
                                            student.result_rank = index + 1;
                                        }
                                    });
                                });
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            async getreport() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                    div: this.div,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/SanjivaniExamination/annualCourseMarksCalculation", data);
                    if (res.data.flag == "YES") {
                        this.leraner_marks = res.data.leraner_marks;
                        this.remarks_list = res.data.remarks_list;
                        this.ass_details_for_marksheet = res.data.ass_details_for_marksheet;
                        this.grade_details = res.data.grade_details
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.fmsg);
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.fetch_loader = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.fetch_loader = false;
                }
            },
            getStandardCourse() {
                this.role = localStorage.getItem("para_role");
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    role: this.role,
                };
                axios
                    .post("/Examination/getStandardCourse_WWS", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = this.sel_std_data.div_list;
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.role = localStorage.getItem("para_role");
                const data = {
                    role: this.role,
                };
                axios
                    .post("/commonAPI/get_ay_std_div_wws",data)
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
 .scroll {
        overflow-x: scroll;
    }
    input[type="number"] {
        width: 70%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        /*  img {
            width: 100% !important;
        }*/
        body,
        tr,
        th,
        td {
            font-size: 14pt !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            /*size: 15.5in 15.5in;*/
            size: 16in 20in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
        .table-data {
            height: 100% !important;
            overflow-x: hidden;
            overflow-y: hidden !important;
        }
    }
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 86%;
    }
    tr:hover {
    background-color: unset  !important;
    cursor: default !important;
    }
    .bg-yellow {
    background-color: yellow !important;
    font-weight: bold;
    }
    .bg-green {
    background-color: green !important;
    font-weight: bold;
    }
    .bg-red {
        background-color: red !important; /* light red */
        font-weight: bold;
    }
    .bg-yellow:hover {
    background-color: yellow !important;

    }
    .bg-red:hover {
        background-color: red !important; /* light red */
    }
    .bg-green:hover {
        background-color: green !important; /* light red */
    }
</style>
